import React from "react";
import {
  DefaultButton,
  PrimaryButton,
  Stack,
} from "@fluentui/react";
import { Formik } from "formik";
import {
  addSLADeviation,
  updateSLADeviation,
} from "../../../services/sla-matrix/SlaMatrixService";
import {
  ISLADeviation,
} from "../../../vm";
import { childrenGap } from "../../common/Constants";
import CustomDrawer from "../../common/CustomDrawer";
import { CustomTextField } from "../../common/Library";
import { ToastContext } from "../../common/ToastProvider";
import * as yup from "yup";

const slaDeviationSchema = yup.object().shape({
  deviation: yup.string().required().max(1050, "Deviation should be less than 1050 characters"),
});

export interface ManageSlaDeviationDialogProps {
  data?: ISLADeviation;
  handleLoading: any;
  handleDialogClose: any;
  customerId: string;
  date: Date;
}

const ManageSlaDeviationDialog: React.FC<ManageSlaDeviationDialogProps> = ({
  data,
  handleDialogClose,
  handleLoading,
  customerId,
  date
}) => {
  //state
  const [state, setState] = React.useState({
    slaDeviation: {
      date: date,
      deviation: "",
      customerId: customerId,
      ...data,
    },
    isLoading: false,
    selectedImage: undefined,
  } as {
    slaDeviation: ISLADeviation;
    isLoading: boolean;
  });

  console.log("data", data);

  //hooks
  const { showToast } = React.useContext(ToastContext);

  const closeAddDialog = (data?: ISLADeviation) => {
    handleDialogClose(data);
  };


  return (
    <React.Fragment>
      <CustomDrawer
        title={
          state.slaDeviation._id
            ? "Update SLA Deviation"
            : "Add SLA Deviation"
        }
        handelOpen={true}
        onClose={() => closeAddDialog()}
      >
        <Stack>
          <Formik
            initialValues={state.slaDeviation}
            validationSchema={slaDeviationSchema}
            onSubmit={async (values: ISLADeviation, { setSubmitting }) => {
              let obj = { ...values };
              let result;
              handleLoading();
              if (state.slaDeviation._id) {
                result = await updateSLADeviation(obj);
              } else {
                result = await addSLADeviation(obj);
              }
              handleLoading();
              if (result.success) {
                closeAddDialog(result.data);
              } else {
                showToast(
                  result?.message ||
                  `Error while ${state.slaDeviation._id ? "updating" : "adding"
                  } sla deviation`,
                  "error"
                );
              }
              setSubmitting(false);
            }}
          >
            {({
              handleSubmit,
              values
            }) => (
              <form onSubmit={handleSubmit}>
                <Stack wrap tokens={childrenGap} className="">
                  <Stack.Item>
                    <CustomTextField name={"deviation"} label={"Deviation"} multiline description={`No of characters ${values.deviation.length} out of 1050`} autoAdjustHeight />
                  </Stack.Item>
                  <Stack.Item>
                    <Stack
                      horizontal
                      wrap
                      tokens={childrenGap}
                      horizontalAlign="end"
                      className="pt-16"
                    >
                      <DefaultButton
                        text="Cancel"
                        onClick={() => closeAddDialog()}
                        className="borderless-btn"
                      />
                      <PrimaryButton
                        type="submit"
                        text={state.slaDeviation._id ? "Update" : "Add"}
                      />
                    </Stack>
                  </Stack.Item>
                </Stack>
              </form>
            )}
          </Formik>
        </Stack>
      </CustomDrawer>
    </React.Fragment>
  );
};

export default ManageSlaDeviationDialog;
